export default "__VITE_ASSET__df6d70c4__"